import script from "./AssignProfessionalModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssignProfessionalModal.vue?vue&type=script&setup=true&lang=ts"

import "./AssignProfessionalModal.vue?vue&type=style&index=0&id=1647d2b7&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1647d2b7"]])

export default __exports__